import { jsx as _jsx } from "react/jsx-runtime";
const WavlakeEmbed = ({ link }) => {
    const convertedUrl = link.replace(/(?:player\.|www\.)?wavlake\.com/, "embed.wavlake.com");
    return (_jsx("iframe", { style: { borderRadius: 12 }, src: convertedUrl, width: "100%", height: "380", frameBorder: "0", loading: "lazy" }));
};
export default WavlakeEmbed;
